export const translations = {
  da: {
    "nav.cases": "Referencer",
    "nav.services": "Ydelser",
    "nav.about": "Om mig",
    "nav.contact": "Kontakt",
    "nav.cta": "Start dit projekt",
    "nav.pricing": "Priser",
    "hero.label": "Webudvikler til nye virksomheder",
    "hero.l1": "Ny",
    "hero.l2": "hjemmeside",
    "hero.l3": "NU.",
    "hero.sub": "Jeg bygger skarpe, hurtige hjemmesider til nystartede virksomheder — fra idé til lancering, uden besvær og uden ventetid.",
    "hero.cta1": "Få en hjemmeside nu",
    "hero.cta2": "Se referencerne",
    "hero.chip": "Svartid",
    "marquee.1": "Ny hjemmeside NU",
    "marquee.2": "Hurtigt",
    "marquee.3": "Flot",
    "marquee.4": "Professionelt",
    "marquee.5": "Uden besvær",
    "gallery.label": "Galleri",
    "gallery.h1": "Website collection",
    "gallery.h2": "klik dig ind",
    "gallery.intro": "Tyve referencer til tyve forskellige virksomhedstyper. Seks af dem kan du klikke ind i og opleve som levende demo-sites — din virksomhed kunne være den næste.",
    "gallery.badge": "Forhåndsvisning",
    "gallery.filterAll": "Alle",
    "pricing.label": "Priser",
    "pricing.h1": "Faste pakker.",
    "pricing.h2": "Ingen overraskelser.",
    "pricing.intro": "Tre faste pakker, så du ved præcist, hvad du får — og hvad det koster — inden du skriver. Alle priser er engangspriser ekskl. moms.",
    "pricing.popular": "Mest valgte",
    "pricing.oneoff": "Engangspris",
    "pricing.cta": "Vælg",
    "pricing.note": "Alle pakker kan tilpasses — skriv via kontaktformularen og få et fast tilbud.",
    "pricing.basis.name": "Basis",
    "pricing.basis.f1": "Én skarp one-page hjemmeside",
    "pricing.basis.f2": "Kontaktformular med besked direkte til din indbakke",
    "pricing.basis.f3": "Perfekt på mobil og tablet",
    "pricing.basis.f4": "Lanceret inden for 1 uge",
    "pricing.plus.name": "Plus",
    "pricing.plus.f1": "Op til 5 sider med dit indhold",
    "pricing.plus.f2": "Alt fra Basis-pakken",
    "pricing.plus.f3": "Galleri eller produkt-visning",
    "pricing.plus.f4": "Grundlæggende SEO, så Google finder dig",
    "pricing.plus.f5": "Lanceret inden for 2 uger",
    "pricing.pro.name": "Pro",
    "pricing.pro.f1": "Webshop, booking eller kunde-login",
    "pricing.pro.f2": "Alt fra Plus-pakken",
    "pricing.pro.f3": "Flere sprog — fx dansk, engelsk og swahili",
    "pricing.pro.f4": "3 måneders support og opdateringer inkluderet",
    "pricing.pro.f5": "Prioriteret levering",
    "manifesto.label": "Manifest · Ydelser",
    "manifesto.heading": "Sådan arbejder jeg",
    "manifesto.1.title": "Design der sælger",
    "manifesto.1.text": "Din hjemmeside er dit vigtigste sælger-redskab. Jeg designer skræddersyede sider, der fanger dine kunder på under tre sekunder — og får dem til at tage kontakt.",
    "manifesto.2.title": "Teknik der bare virker",
    "manifesto.2.text": "Lynhurtig indlæsning, perfekt på mobilen og nem at finde på Google. Du skal ikke tænke på teknikken — det klarer jeg. Du får en side, der bare virker. Hver gang.",
    "manifesto.3.title": "Tryghed hele vejen",
    "manifesto.3.text": "Jeg forsvinder ikke efter lancering. Du får løbende support, opdateringer og en direkte linje til mig — svar inden for 24 timer, altid.",
    "about.label": "Om mig",
    "about.h1": "Manden bag",
    "about.h2": "tastaturet",
    "about.caption": "Gert — Webudvikler",
    "about.p1a": "Hej, jeg hedder Gert. Jeg startede ",
    "about.p1b": ", fordi jeg så alt for mange nye virksomheder vente månedsvis — og betale alt for meget — for en hjemmeside, der burde tage uger, ikke kvartaler.",
    "about.p2": "Hos mig får du én fast kontaktperson, ærlige priser og en hjemmeside, der er skræddersyet til netop din virksomhed. Ingen bureaukrati, ingen mellemled — bare en side der virker.",
    "about.s1": "Webdesign",
    "about.s2": "Webshop",
    "about.s3": "SEO",
    "about.s4": "Vedligeholdelse",
    "about.s5": "Hurtig levering",
    "about.s6": "Personlig sparring",
    "contact.label": "Kontakt",
    "contact.h1": "Skal vi bygge",
    "contact.h2": "din",
    "contact.h2accent": "nu?",
    "contact.text": "Fortæl mig kort om din virksomhed, så vender jeg tilbage med idéer og en fast pris — helt uforpligtende. Beskeden lander direkte i min indbakke.",
    "contact.responseA": "Svar inden for",
    "contact.responseB": "24 timer",
    "contact.fName": "Dit navn",
    "contact.fEmail": "Din e-mail",
    "contact.fMessage": "Din besked",
    "contact.pName": "F.eks. Mette Hansen",
    "contact.pEmail": "dig@dinvirksomhed.dk",
    "contact.pMessage": "Jeg starter en ny café og har brug for en hjemmeside med menu og booking...",
    "contact.submit": "Send besked",
    "contact.sending": "Sender...",
    "contact.toastOk": "Tak for din besked! Den er sendt direkte til min indbakke — jeg vender tilbage inden for 24 timer.",
    "contact.toastErr": "Noget gik galt. Prøv igen.",
    "footer.copy": "© 2026 Ny hjemmeside NU — Bygget med omhu i Danmark",
    "footer.admin": "Admin",
    "demobar.demo": "Demo-site:",
    "demobar.by": "— bygget af",
    "demobar.back": "Tilbage",
    "demobar.cta": "Få din egen",
    "admin.label": "Admin",
    "admin.title": "Henvendelser",
    "admin.loginSub": "Log ind for at se dine henvendelser",
    "admin.emailPh": "E-mail",
    "admin.passPh": "Adgangskode",
    "admin.loginBtn": "Log ind",
    "admin.backHome": "Tilbage til forsiden",
    "admin.home": "Forsiden",
    "admin.logout": "Log ud",
    "admin.empty": "Ingen henvendelser endnu — de dukker op her, når kunder skriver via kontaktformularen.",
    "admin.welcome": "Velkommen tilbage!",
    "admin.proofBtn": "Send korrektur-ark",
    "admin.proofOk": "Korrektur-arket er sendt til din indbakke — videresend det til din swahili-korrekturlæser.",
    "admin.error": "Noget gik galt. Prøv igen.",
  },
  en: {
    "nav.cases": "Work",
    "nav.services": "Services",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.cta": "Start your project",
    "nav.pricing": "Pricing",
    "hero.label": "Web developer for new businesses",
    "hero.l1": "New",
    "hero.l2": "website",
    "hero.l3": "NOW.",
    "hero.sub": "I build sharp, fast websites for newly started businesses — from idea to launch, without hassle and without waiting.",
    "hero.cta1": "Get a website now",
    "hero.cta2": "See the work",
    "hero.chip": "Response time",
    "marquee.1": "New website NOW",
    "marquee.2": "Fast",
    "marquee.3": "Beautiful",
    "marquee.4": "Professional",
    "marquee.5": "No hassle",
    "gallery.label": "Gallery",
    "gallery.h1": "Website collection",
    "gallery.h2": "click inside",
    "gallery.intro": "Twenty cases for twenty different business types. Six of them can be clicked into and experienced as live demo sites — your business could be next.",
    "gallery.badge": "Preview",
    "gallery.filterAll": "All",
    "pricing.label": "Pricing",
    "pricing.h1": "Fixed packages.",
    "pricing.h2": "No surprises.",
    "pricing.intro": "Three fixed packages, so you know exactly what you get — and what it costs — before you write. All prices are one-off, excl. VAT.",
    "pricing.popular": "Most popular",
    "pricing.oneoff": "One-off price",
    "pricing.cta": "Choose",
    "pricing.note": "All packages can be tailored — write via the contact form and get a fixed quote.",
    "pricing.basis.name": "Basic",
    "pricing.basis.f1": "One sharp one-page website",
    "pricing.basis.f2": "Contact form with messages straight to your inbox",
    "pricing.basis.f3": "Perfect on mobile and tablet",
    "pricing.basis.f4": "Launched within 1 week",
    "pricing.plus.name": "Plus",
    "pricing.plus.f1": "Up to 5 pages with your content",
    "pricing.plus.f2": "Everything from the Basic package",
    "pricing.plus.f3": "Gallery or product showcase",
    "pricing.plus.f4": "Basic SEO so Google finds you",
    "pricing.plus.f5": "Launched within 2 weeks",
    "pricing.pro.name": "Pro",
    "pricing.pro.f1": "Webshop, booking or customer login",
    "pricing.pro.f2": "Everything from the Plus package",
    "pricing.pro.f3": "Multiple languages — e.g. Danish, English and Swahili",
    "pricing.pro.f4": "3 months of support and updates included",
    "pricing.pro.f5": "Priority delivery",
    "manifesto.label": "Manifesto · Services",
    "manifesto.heading": "How I work",
    "manifesto.1.title": "Design that sells",
    "manifesto.1.text": "Your website is your most important sales tool. I design tailor-made sites that catch your customers in under three seconds — and make them get in touch.",
    "manifesto.2.title": "Tech that just works",
    "manifesto.2.text": "Lightning-fast loading, perfect on mobile and easy to find on Google. You don't have to think about the tech — I handle that. You get a site that just works. Every time.",
    "manifesto.3.title": "Support all the way",
    "manifesto.3.text": "I don't disappear after launch. You get ongoing support, updates and a direct line to me — answers within 24 hours, always.",
    "about.label": "About me",
    "about.h1": "The man behind",
    "about.h2": "the keyboard",
    "about.caption": "Gert — Web developer",
    "about.p1a": "Hi, I'm Gert. I started ",
    "about.p1b": " because I saw too many new businesses wait for months — and pay far too much — for a website that should take weeks, not quarters.",
    "about.p2": "With me you get one permanent contact, honest prices and a website tailor-made for your business. No bureaucracy, no middlemen — just a site that works.",
    "about.s1": "Web design",
    "about.s2": "Webshop",
    "about.s3": "SEO",
    "about.s4": "Maintenance",
    "about.s5": "Fast delivery",
    "about.s6": "Personal sparring",
    "contact.label": "Contact",
    "contact.h1": "Shall we build",
    "contact.h2": "yours",
    "contact.h2accent": "now?",
    "contact.text": "Tell me briefly about your business, and I'll get back to you with ideas and a fixed price — completely non-binding. The message lands directly in my inbox.",
    "contact.responseA": "Reply within",
    "contact.responseB": "24 hours",
    "contact.fName": "Your name",
    "contact.fEmail": "Your email",
    "contact.fMessage": "Your message",
    "contact.pName": "E.g. Mette Hansen",
    "contact.pEmail": "you@yourbusiness.com",
    "contact.pMessage": "I'm starting a new café and need a website with a menu and booking...",
    "contact.submit": "Send message",
    "contact.sending": "Sending...",
    "contact.toastOk": "Thanks for your message! It's been sent straight to my inbox — I'll get back to you within 24 hours.",
    "contact.toastErr": "Something went wrong. Please try again.",
    "footer.copy": "© 2026 Ny hjemmeside NU — Built with care in Denmark",
    "footer.admin": "Admin",
    "demobar.demo": "Demo site:",
    "demobar.by": "— built by",
    "demobar.back": "Back",
    "demobar.cta": "Get your own",
    "admin.label": "Admin",
    "admin.title": "Inquiries",
    "admin.loginSub": "Log in to see your inquiries",
    "admin.emailPh": "Email",
    "admin.passPh": "Password",
    "admin.loginBtn": "Log in",
    "admin.backHome": "Back to the front page",
    "admin.home": "Front page",
    "admin.logout": "Log out",
    "admin.empty": "No inquiries yet — they'll show up here when customers write via the contact form.",
    "admin.welcome": "Welcome back!",
    "admin.proofBtn": "Email proof sheet",
    "admin.proofOk": "The proofreading sheet has been sent to your inbox — forward it to your Swahili proofreader.",
    "admin.error": "Something went wrong. Please try again.",
  },
  sw: {
    "nav.cases": "Kazi",
    "nav.services": "Huduma",
    "nav.about": "Kunihusu",
    "nav.contact": "Mawasiliano",
    "nav.cta": "Anza mradi wako",
    "nav.pricing": "Bei",
    "hero.label": "Mjenzi wa tovuti kwa biashara mpya",
    "hero.l1": "Tovuti",
    "hero.l2": "mpya",
    "hero.l3": "SASA.",
    "hero.sub": "Ninajenga tovuti kali na za haraka kwa biashara mpya — kutoka wazo hadi uzinduzi, bila msukosuko na bila kusubiri.",
    "hero.cta1": "Pata tovuti sasa",
    "hero.cta2": "Tazama kazi zangu",
    "hero.chip": "Muda wa kujibu",
    "marquee.1": "Tovuti mpya SASA",
    "marquee.2": "Haraka",
    "marquee.3": "Nzuri",
    "marquee.4": "Kitaalamu",
    "marquee.5": "Bila msukosuko",
    "gallery.label": "Matunzio",
    "gallery.h1": "Website collection",
    "gallery.h2": "bofya ndani",
    "gallery.intro": "Kazi ishirini kwa aina ishirini tofauti za biashara. Sita kati zao unaweza kubofya ndani na kuzipitia kama tovuti hai — biashara yako inaweza kuwa inayofuata.",
    "gallery.badge": "Mwonekano",
    "gallery.filterAll": "Zote",
    "pricing.label": "Bei",
    "pricing.h1": "Paketi maalum.",
    "pricing.h2": "Hakuna mshangao.",
    "pricing.intro": "Paketi tatu za bei maalum, ili ujue kabisa unachopata — na bei yake — kabla ya kuandika. Bei zote ni za mara moja, bila VAT.",
    "pricing.popular": "Inayopendwa zaidi",
    "pricing.oneoff": "Bei ya mara moja",
    "pricing.cta": "Chagua",
    "pricing.note": "Paketi zote zinaweza kubadilishwa — andika kupitia fomu ya mawasiliano na upate ofa maalum.",
    "pricing.basis.name": "Msingi",
    "pricing.basis.f1": "Tovuti moja kali ya ukurasa mmoja",
    "pricing.basis.f2": "Fomu ya mawasiliano inayotuma ujumbe moja kwa moja kwenye kisanduku chako",
    "pricing.basis.f3": "Kamili kwenye simu na kibao",
    "pricing.basis.f4": "Inazinduliwa ndani ya wiki 1",
    "pricing.plus.name": "Plus",
    "pricing.plus.f1": "Hadi kurasa 5 na maudhui yako",
    "pricing.plus.f2": "Kila kitu kutoka paketi ya Msingi",
    "pricing.plus.f3": "Matunzio au onyesho la bidhaa",
    "pricing.plus.f4": "SEO ya msingi ili Google ikupate",
    "pricing.plus.f5": "Inazinduliwa ndani ya wiki 2",
    "pricing.pro.name": "Pro",
    "pricing.pro.f1": "Duka la mtandaoni, kuweka nafasi au kuingia kwa wateja",
    "pricing.pro.f2": "Kila kitu kutoka paketi ya Plus",
    "pricing.pro.f3": "Lugha nyingi — mf. Kidenmark, Kiingereza na Kiswahili",
    "pricing.pro.f4": "Msaada na masasisho ya miezi 3 yamejumuishwa",
    "pricing.pro.f5": "Uwasilishaji wa kipaumbele",
    "manifesto.label": "Manifesto · Huduma",
    "manifesto.heading": "Jinsi ninavyofanya kazi",
    "manifesto.1.title": "Muundo unaouza",
    "manifesto.1.text": "Tovuti yako ni chombo chako muhimu zaidi cha mauzo. Ninaunda tovuti maalum zinazowavutia wateja wako kwa chini ya sekunde tatu — na kuwafanya wawasiliane nawe.",
    "manifesto.2.title": "Teknolojia inayofanya kazi tu",
    "manifesto.2.text": "Upakiaji wa haraka kama umeme, kamili kwenye simu na rahisi kupatikana kwenye Google. Huna haja ya kufikiria teknolojia — mimi hushughulika. Unapata tovuti inayofanya kazi tu. Kila wakati.",
    "manifesto.3.title": "Msaada njia nzima",
    "manifesto.3.text": "Sitowepi baada ya uzinduzi. Unapata msaada unaoendelea, masasisho na njia ya moja kwa moja kwangu — majibu ndani ya masaa 24, kila wakati.",
    "about.label": "Kunihusu",
    "about.h1": "Mtu aliye",
    "about.h2": "nyuma ya kibodi",
    "about.caption": "Gert — Mjenzi wa tovuti",
    "about.p1a": "Habari, mimi ni Gert. Nilianzisha ",
    "about.p1b": " kwa sababu niliona biashara nyingi mpya zakisubiri kwa miezi — na kulipa pesa nyingi mno — kwa tovuti ambayo ingepaswa kuchukua wiki, si miezi.",
    "about.p2": "Kwangu unapata mtu mmoja wa kudumu wa kuwasiliana naye, bei za kweli na tovuti iliyotengenezwa mahsusi kwa biashara yako. Hakuna urasimu, hakuna wapatanishi — tovuti inayofanya kazi tu.",
    "about.s1": "Muundo wa tovuti",
    "about.s2": "Duka la mtandaoni",
    "about.s3": "SEO",
    "about.s4": "Matengenezo",
    "about.s5": "Uwasilishaji wa haraka",
    "about.s6": "Ushauri wa kibinafsi",
    "contact.label": "Mawasiliano",
    "contact.h1": "Je, tuijenge",
    "contact.h2": "yako",
    "contact.h2accent": "sasa?",
    "contact.text": "Niambie kwa ufupi kuhusu biashara yako, na nitakujibu na mawazo na bei maalum — bila kujifunga kabisa. Ujumbe unaingia moja kwa moja kwenye kisanduku changu.",
    "contact.responseA": "Jibu ndani ya",
    "contact.responseB": "masaa 24",
    "contact.fName": "Jina lako",
    "contact.fEmail": "Barua pepe yako",
    "contact.fMessage": "Ujumbe wako",
    "contact.pName": "Mf. Mette Hansen",
    "contact.pEmail": "wewe@biasharayako.com",
    "contact.pMessage": "Ninaanzisha mkahawa mpya na ninahitaji tovuti yenye menyu na kuweka nafasi...",
    "contact.submit": "Tuma ujumbe",
    "contact.sending": "Inatuma...",
    "contact.toastOk": "Asante kwa ujumbe wako! Umetumwa moja kwa moja kwenye kisanduku changu — nitakujibu ndani ya masaa 24.",
    "contact.toastErr": "Hitilafu imetokea. Jaribu tena.",
    "footer.copy": "© 2026 Ny hjemmeside NU — Imejengwa kwa upendo nchini Denmark",
    "footer.admin": "Admin",
    "demobar.demo": "Tovuti ya onyesho:",
    "demobar.by": "— imejengwa na",
    "demobar.back": "Rudi",
    "demobar.cta": "Pata yako",
    "admin.label": "Admin",
    "admin.title": "Ujumbe",
    "admin.loginSub": "Ingia kuona ujumbe wako",
    "admin.emailPh": "Barua pepe",
    "admin.passPh": "Nenosiri",
    "admin.loginBtn": "Ingia",
    "admin.backHome": "Rudi kwenye ukurasa wa mwanzo",
    "admin.home": "Ukurasa wa mwanzo",
    "admin.logout": "Toka",
    "admin.empty": "Hakuna ujumbe bado — utaonekana hapa wateja watakapoandika kupitia fomu ya mawasiliano.",
    "admin.welcome": "Karibu tena!",
    "admin.proofBtn": "Tuma karatasi ya sahihisho",
    "admin.proofOk": "Karatasi ya sahihisho imetumwa kwenye kisanduku chako — mpe msahihishi wako wa Kiswahili.",
    "admin.error": "Hitilafu imetokea. Jaribu tena.",
  },
};
